module.exports = __webpack_public_path__ + "img/settings.11da798e.svg";